// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcn_a bhe_b bhe_uy bhe_rt bhe_ru bhe_vs","PanelFooter--link":"bcn_b"};